import { createFileRoute, Link } from '@tanstack/react-router';
import { Phone, FileText, Euro } from 'lucide-react';
import { AppShell } from '@/components/layout/AppShell';
import { StatCard } from '@/components/dashboard/StatCard';
import { CallRow } from '@/components/dashboard/CallRow';
import { AgentPanel } from '@/components/dashboard/AgentPanel';
import { ScheduleCard } from '@/components/dashboard/ScheduleCard';
import { MOCK_CALLS, MOCK_SCHEDULE } from '@/data/mock';

export const Route = createFileRoute('/')({
  component: DashboardPage,
});

const SPARK_CALLS    = 'M0 32L15 28 30 30 45 18 60 22 75 10 90 14';
const SPARK_QUOTES   = 'M0 26L15 24 30 28 45 20 60 24 75 16 90 18';
const SPARK_REVENUE  = 'M0 34L15 30 30 26 45 24 60 16 75 14 90 8';

function DashboardPage() {
  return (
    <AppShell pageTitle="Dober dan, Marko" crumb="TradeCraft · Pregled">
      {/* ---- Stat cards ---- */}
      <div className="dash-grid">
        <StatCard
          label="Klici danes"
          icon={<Phone size={15} strokeWidth={1.6} />}
          value="7"
          delta="▲ 3 več kot včeraj"
          deltaUp
          sparkPath={SPARK_CALLS}
        />
        <StatCard
          label="Ponudbe v teku"
          icon={<FileText size={15} strokeWidth={1.6} />}
          value="4"
          delta="2 čakata na odgovor"
          sparkPath={SPARK_QUOTES}
        />
        <StatCard
          label="Prihodek mesec"
          icon={<Euro size={15} strokeWidth={1.6} />}
          value="€3.840"
          delta="▲ 18 % vs. prejšnji"
          deltaUp
          sparkPath={SPARK_REVENUE}
        />
      </div>

      {/* ---- Two-column section ---- */}
      <div className="dash-cols">
        {/* Recent calls */}
        <div className="app-card" style={{ padding: '1.25rem' }}>
          <div className="card-head">
            <h3 style={{
              fontFamily: 'var(--font-display)',
              fontWeight: 540,
              fontSize: '1.05rem',
              color: '#fff',
            }}>
              Zadnji klici
            </h3>
            <Link
              to="/klici"
              style={{
                fontSize: '0.78rem',
                color: 'var(--copper-300)',
                fontFamily: 'var(--font-mono)',
                letterSpacing: '0.02em',
                textDecoration: 'none',
              }}
            >
              Vsi klici →
            </Link>
          </div>

          <div>
            {MOCK_CALLS.slice(0, 4).map((call) => (
              <CallRow key={call.id} call={call} />
            ))}
          </div>
        </div>

        {/* Right column: agent + schedule */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
          <AgentPanel />
          <ScheduleCard items={MOCK_SCHEDULE} />
        </div>
      </div>
    </AppShell>
  );
}
